<template>
  <div>
    <div class="page-title">
      {{ $t('data.transactions_summary') }}

    </div>
    <div class="page-container">

      <div class="filter-right-container">
        <!-- <div class="filter-container-tag" style="position: static;text-align: left;margin-bottom: 24px;">
          {{ $t('data.total_transaction_details') }}
        </div> -->
        <span class="transTime">{{ $t('merchantAccount.transaction_date') }}:</span>
        <el-date-picker
          v-model="search.times"
          class="mb-10 picker"

          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="~"
          :picker-options="pickerOptions"
          :start-placeholder="$t('components.start_date')"
          :end-placeholder="$t('components.end_date')"
        />
        <el-button class="search-btn mb-10" type="primary" icon="el-icon-search" @click="handleFilter">{{ $t('components.search') }}</el-button>

      </div>

      <div class="total-container">
        <div class="total-item">
          <div class="total-item-text"> {{ $t('data.collection_amount') }}</div>
          <div class="color-main-linear-blue total-item-num">{{ dateBetweenTransSum.total_payment_amount | toDivideWithDot }}</div>
        </div>

        <div class="total-item">
          <div class="total-item-text"> {{ $t('data.collection_number') }}</div>
          <div class="color-main-linear-blue total-item-num">{{ dateBetweenTransSum.total_payment_count || 0 }}</div>
        </div>
        <div class="total-item">
          <div class="total-item-text"> {{ $t('data.collection_commission') }}</div>
          <div class="color-main-linear-blue total-item-num">{{ dateBetweenTransSum.total_payment_commission| toDivideWithDot }}</div>
        </div>
        <div class="total-item">
          <div class="total-item-text"> {{ $t('data.loan_amount') }}</div>
          <div class="color-main-linear-blue total-item-num">{{ dateBetweenTransSum.total_payout_amount | toDivideWithDot }}</div>
        </div>
        <div class="total-item">
          <div class="total-item-text"> {{ $t('data.loan_number') }}</div>
          <div class="color-main-linear-blue total-item-num">{{ dateBetweenTransSum.total_payout_count || 0 }}</div>
        </div>
        <div class="total-item">
          <div class="total-item-text"> {{ $t('data.loan_commission') }}</div>
          <div class="color-main-linear-blue total-item-num">{{ dateBetweenTransSum.total_payout_commission| toDivideWithDot }}</div>
        </div>
      </div>
      <div class="tips"><span><svg-icon icon-class="icon-font-warning" style="color: #488CE8;" /></span>{{ $t('tips.current_time_zone') }}</div>
      <div class="tableContainer">
        <el-table
          v-loading="listLoading"
          :data="tableData"
          stripe
          fit
          highlight-current-row
          style="width: 100%"
        >

          <el-table-column :label="$t('merchantAccount.transaction_date')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.statistic_date ? scope.row.statistic_date.split('00:00:00')[0] : scope.row.statistic_date }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('data.collection_amount')" prop="payment_amount" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.payment_amount | toDivideWithDot }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('data.collection_number')" prop="payment_count" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.payment_count }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('data.collection_commission')" prop="payment_commission_split" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.payment_commission | toDivideWithDot }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('data.loan_amount')" prop="payout_amount" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.payout_amount | toDivideWithDot }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('data.loan_number')" prop="payout_count" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.payout_count }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('data.loan_commission')" prop="payout_commission_split" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.payout_commission | toDivideWithDot }}</span>
            </template>
          </el-table-column>

        </el-table>

        <div class="pagination-container">
          <paginator v-if="!listLoading" :list-query="listQuery" @paginator-change="onClickPaginator" />
        </div>
      </div>
    </div>
  </div></template>

<script>

import { fetchTransSumList, fetchTransSumListAll, fetchTransSumData } from '@/api/data/data'

import { filterEmptyAttr, exportXlsx, exportXlsxFitWidth } from '@/utils/common'
import { appointDate } from '@/utils/index.js'

export default {
  name: 'Pay_Trans_Details',
  components: {
    Paginator: () => import('@/views/components/Paginator')
  },
  data() {
    return {
      search: {
        times: [appointDate(-3), appointDate(-1)],
        app_name: ''
      },
      tableData: [],
      pageTotal: [],
      dateBetweenTransSum: {},
      total_amount: 0,
      total_commission: 0,
      total_count: 0,
      listLoading: false,
      isClassify: '0',
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      },
      pickerOptions: {
        disabledDate: this.disabledDate
      }
    }
  },
  created() {
    this.getTransSumInfo()
  },
  methods: {
    disabledDate(time) {
      return time.getTime() > (Date.now() - 60 * 60 * 24 * 1000)
    },
    getTransSumInfo(otherParams) {
      this.listLoading = true
      const params = this.getParams(otherParams)
      const fn = [fetchTransSumList(params)]
      Promise.all(fn).then(res => {
        const [transListData = {}] = res
        if (transListData.code === 10000) {
          const { total = 0, list = [], ...otherData } = transListData.data || {}
          this.dateBetweenTransSum = otherData
          this.listQuery.total = total
          this.listQuery.page = params.page ? params.page : 1
          this.tableData = list
        }
      }).finally(() => {
        this.listLoading = false
      })
    },

    getParams(otherParams = {}) {
      const { times = [] } = this.search
      let params = {
        start_time: times && times[0],
        end_time: times && times[1],
        ...otherParams
      }
      params = filterEmptyAttr(params)
      return params
    },

    getSummaries(params) {
      const { columns, data } = params
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = 'Total'
          this.pageTotal[index] = 'Total'
          return
        }
        const values = data.map(item => Number(item[column.property]))
        const needTotalCol = ['payment_amount', 'payment_count', 'payment_commission_split', 'payout_amount', 'payout_count', 'payout_commission_split']
        const notNeedToDivide = ['payment_count', 'payout_count']
        if (!needTotalCol.includes(column.property)) {
          sums[index] = '-'
          this.pageTotal[index] = '-'
          return
        } else {
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + value
              } else {
                return prev
              }
            }, 0)
            const toDivideWithDot = this.$options.filters['toDivideWithDot']
            if (!notNeedToDivide.includes(column.property)) {
              sums[index] = toDivideWithDot(sums[index])
            }

            // 用于下载
            this.pageTotal[index] = sums[index]
          } else {
            sums[index] = 'N/A'
            this.pageTotal[index] = 'N/A'
          }
          return
        }
      })

      return sums
    },

    handleFilter(otherParams = {}) {
      const params = this.getParams(otherParams)
      if (!params) {
        return
      }
      if (!params.start_time) {
        this.$message.warning('Transaction time is required!')
        return
      }
      this.getTransSumInfo(params)
    },
    onClickDowmloadBtn() {
      const params = this.getParams()
      if (!this.$commonFn.checkSubmitDateLimit(this.search.times, 90)) {
        this.$message.warning('The maximum date range  is limited to 90 days, please select again')
        return
      }
      if (!params) {
        return
      }
      fetchTransSumListAll(params).then(res => {
        if (res.code === 10000) {
          const data = res.data || []
          this.handleXlsxData(data).then((downloadData) => {
            exportXlsxFitWidth(downloadData, 'Transaction_Summary')
          })
        }
      })
    },
    // displayChange(){
    //   this.handleFilter()
    // },
    handleXlsxData(data = []) {
      const rows = [[
        this.$t('components.date'),
        this.$t('data.collection_amount'),
        this.$t('data.collection_number'),
        this.$t('data.collection_commission'),
        this.$t('data.loan_amount'),
        this.$t('data.loan_number'),
        this.$t('data.loan_commission'),
        this.$t('merchant.app_name')
      ]]

      const toDivide100 = this.$options.filters['toDivide100']
      if (Array.isArray(data) && data.length > 0) {
        data.forEach((tr) => {
          rows.push([
            tr.statistic_date ? tr.statistic_date.split('00:00:00')[0] : tr.statistic_date,
            toDivide100(tr.payment_amount),
            tr.payment_count,
            toDivide100(tr.payment_commission_split),
            toDivide100(tr.payout_amount),
            tr.payout_count,
            toDivide100(tr.payout_commission_split),
            tr.app_name ? tr.app_name : '--'
          ])
        })
      }
      return Promise.resolve(rows)
    },
    onClickPaginator() {
      this.handleFilter(this.listQuery)
    }
  }
}
</script>
<style scoped>
/* .tableContainer .el-table /deep/.el-table__footer-wrapper td{
  border-top: 1px solid #D5D8DE;
}
.tableContainer .el-table /deep/.el-table__footer-wrapper tr td{
  border-right: 1px solid #D5D8DE;
}
.tableContainer .el-table /deep/.el-table__footer-wrapper tr .el-table_1_column_7{
    border-right: none;
}
.tableContainer .el-table /deep/.el-table__footer-wrapper td .cell{
  font-weight: 700;  font-family: 'Poppins-Bold';
  font-size: 17px;
} */
</style>

<style lang="scss" scoped>

.page-container .page-title{
  padding-bottom: 24px;
  border-bottom: 1px solid #D3D7DF;
}
.page-container{

  .transTime{
    display: inline-block;
    padding: 0 20px 10px 0;
    font-size: 14px;
    font-weight: 500;  font-family: 'Poppins-Medium';
    color: #606266;
  }
  .monthly-summary{
    font-weight: 500;  font-family: 'Poppins-Medium';
    font-size: 16px;
    background: linear-gradient(180deg, #488CE8 0%, #0058CF 100%);
background-clip: text;
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;;
  }
  .filter-container{
    margin-top: 20px;
    text-align: right;
    margin-bottom: 20px;
  }
  .search-frame {
    width: 160px;
    margin-right: 10px;
  }

  .search-btn {
    margin-right: 10px;
  }
  .classify-switch{
    margin: 0px;
    display: inline-block;
    padding: 0 20px 10px 0;
    font-size: 14px;
    font-weight: 500;  font-family: 'Poppins-Medium';
   }
  .download-btn{
    margin: 0;
  }
  .picker{
    margin-right: 10px;
  }
  .mb-10{
    margin-bottom: 10px;
  }
  .total{
    display: flex;
    justify-content: space-between;
    margin-top: 32px;
    margin-right: 40px;
    // .total-item{
    //   position: relative;
    // }
    .line{
      display: inline-block;
      content:'';
      height: 60px;
      width: 1px;
      background: #D3D7DF;
    }
    &-title{
      font-size: 14px;
      line-height: 17px;
      color: #606266;
    }
    &-num{
      margin-top: 16px;
      padding-bottom: 32px;
      font-size: 18px;
      font-family: Source Han Sans SC;
      font-weight: bold;
      line-height: 24px;
      color: #3855F1;
    }
  }
  .tips{
    border-radius: 4px;
    border: 1px solid #D3D7DF;
    padding: 10px 12px;
    margin-bottom: 32px;
    color: #7A869E;
    width: max-content;
    font-size: 12px;
    span{
      padding-right: 11px;
    }
  }
}
.total-container{
    display: flex;

    margin-bottom: 48px;
    .total-item{
      padding: 12px;
      flex: 1;
      font-weight: 600;
      font-size: 12px;
      color: #364250;
      border: 1px solid rgba(54, 66, 80, 0.20);
      border-radius: 8px;
      .total-item-text{
        margin-bottom: 12px;
      }
      .total-item-num{
        font-size: 20px;
        font-weight: 600;
      }
    }
    .total-item:not(:last-child){
      margin-right: 12px;
    }
  }

</style>
